<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isAddNewUserSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @change="(val) => $emit('update:is-add-new-user-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <b-card>
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Tambah Dosen
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <b-form class="mt-2">
      <b-row>
        <b-col sm="12">
          <b-form-group
            label="Nama"
            label-for="nama"
          >
            <b-form-input
              v-model="userData.nama"
              name="nama"
              placeholder="nama"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group
            label="NIP"
            label-for="nip"
          >
            <b-form-input
              v-model="userData.nip"
              name="nip"
              placeholder="NIP"
              type="number"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group
            label="NIDN"
            label-for="nidn"
          >
            <b-form-input
              v-model="userData.nidn"
              name="nidn"
              placeholder="NIDN"
              type="number"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group
            label="HRIS"
            label-for="hris"
          >
            <b-form-input
              v-model="userData.hris"
              name="hris"
              placeholder="HRIS"
              type="text"
            />
          </b-form-group>
        </b-col>
         <b-col sm="12">
          <b-form-group
            label="Status Kepegawaian"
            label-for="status_kepegawaian"
          >
            <b-form-input
              v-model="userData.status_kepegawaian"
              name="status_kepegawaian"
              placeholder="Status kepegawaian"
            />
          </b-form-group>
        </b-col>
         <b-col sm="12">
          <b-form-group
            label="Fungsi Jabatan"
            label-for="fungsi_jabatan"
          >
            <b-form-input
              v-model="userData.fungsi_jabatan"
              name="fungsi_jabatan"
              placeholder="Fungsi Jabatan"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group
            label="Pangkat"
            label-for="pangkat"
          >
            <b-form-input
              v-model="userData.pangkat"
              name="pangkat"
              placeholder="Pangkat"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group
            label="Golongan"
            label-for="golongan"
          >
            <b-form-input
              v-model="userData.golongan"
              name="golongan"
              placeholder="Golongan"
            />
          </b-form-group>
        </b-col>
         <b-col sm="12">
          <b-form-group
            label="Prodi"
            label-for="prodi"
          >
            <b-form-input
              v-model="userData.prodi"
              name="prodi"
              placeholder="Prodi"
            />
          </b-form-group>
        </b-col>
         <b-col sm="12">
          <b-form-group
            label="Pendidikan"
            label-for="pendidikan"
          >
            <b-form-input
              v-model="userData.pendidikan"
              name="pendidikan"
              placeholder="Pendidikan"
            />
          </b-form-group>
        </b-col>
         <b-col sm="12">
          <b-form-group
            label="No Serdos"
            label-for="No Serdos"
          >
            <b-form-input
              v-model="userData.no_serdos"
              name="No Serdos"
              placeholder="No Serdos"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-2 mr-1"
            @click="simpanData"
          >
            Simpan
          </b-button>
        </b-col>
      </b-row>
    </b-form>
      </b-card>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BRow, BCol,BCard,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
extend('required', {
    ...required,
    message: 'Bagian ini wajib diisi',
});
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import countries from '@/connection-api/data/other/countries'
import store from '@/store'
import {
  postDosen,
} from '@/connection-api/master'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BCard,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-user-sidebar-active',
  },
  props: {
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      userData: {},
      required,
      alphaNum,
      email,
      countries,
      configs: {
        basic: {},
        wrap: {
          wrap: true,
          altFormat: 'M j, Y',
          altInput: true,
          dateFormat: 'Y-m-d',
        },
      },
      proyekOptions: {
        selected: 'id',
        options: [
          { value: null, label: 'Semua' },
        ],
      },
    }
  },
  methods: {
    simpanData() {
      store.dispatch('dosen/addData', this.userData)
        .then(response => {
          if (response.data.success === true) {
            this.makeToast('success', 'Data berhasil disimpan.')
            this.$emit('refetchData')
            this.userData.nama = null
            this.userData.nip = null
            this.userData.nidn = null
            this.userData.status_kepegawaian = null
            this.userData.fungsi_jabatan = null
            this.userData.pangkat = null
            this.userData.golongan = null
            this.userData.prodi = null
            this.userData.pendidikan = null
            this.userData.no_serdos = null
          } else {
            this.makeToast('danger', response.data.message)
          }
        })
        .catch(error => {
        })
    },
    makeToast(variant = null, message = null, title = null) {
      this.$bvToast.toast(message, {
        title: 'Dosen',
        variant,
        solid: true,
        autoHideDelay: 3000,
        enableHtml: true,
        allowHtml: true,
      })
    },
    mappingSelectOption(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.id,
          })
        })
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
